import { Component, OnInit } from '@angular/core';
import { NumberToWordsPipe } from "./../number-to-words.pipe";
import { Router, ActivatedRoute, Params } from "@angular/router";

@Component({
  selector: 'app-scrap',
  templateUrl: './scrap.component.html',
  styleUrls: ['./scrap.component.css', './../billData/bill.component.css']
})
export class ScrapComponent implements OnInit {

  invoiceNo: any;
  invoiceDate: any;

  invoiceDate2: any;
  billToCompanyName: any = "NagaraJ Iron Traders ";
  companyAddress1: any = "SF NO- 359/1,RammannanNagar";
  companyAddress2: any = "ThadagamRoad,Edayarpalayam";
  companyCity: any = "Coimbatore-641025";
  companyPhone: any = " 9363107629";
  companyGST: any = "33ALBPN9493L1ZJ";

  itemsArray: any = [];

  billHSNCode: any;
  billDesc: any;
  billQuantity: any;
  billUnitPrice: any;
  subTotal: any;

  cgstRupee: any;
  sgstRupee: any;
  totIncGst: any;
  totIncGstRupeeWord: any;

  constructor(private numberToWordsPipe: NumberToWordsPipe, private router: Router,
  ) { }

  ngOnInit() {

    let modal = document.getElementById("myModal");
    let btn = document.getElementById("myBtn");
    let span = document.getElementById("close");
    btn.onclick = function () {
      modal.style.display = "block";
    };
    span.onclick = function () {
      modal.style.display = "none";
    };
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  }

  backToHome() {
    this.router.navigate(["/home"]);
  }

  setNewInvoiceDate(event) {
    console.log(event)
  }

  deleteItem(data) {
    let arrayCount = 0;
    this.itemsArray.forEach((element) => {
      arrayCount++;
      if (element === data) {
        this.itemsArray.splice(arrayCount - 1, 1);
      }
    });
  }

  addItem() {

    console.log("Add item", this.billUnitPrice);

    let obj = {
      hsnCode: this.billHSNCode,
      description: this.billDesc,
      quantity: this.billQuantity,
      unitPrice: this.billUnitPrice,
      total: this.billQuantity * this.billUnitPrice,
    }

    console.log(obj)

    this.itemsArray.push(obj);

    console.log(this.itemsArray);

    this.billHSNCode = null;
    this.billDesc = null;
    this.billUnitPrice = null;
    this.billQuantity = null;

  }

  loadBill = function () {

    console.log(this.invoiceNo)

    if (this.invoiceDate) {
      this.invoiceDate2 =
        this.invoiceDate.split("-")[2] +
        "/" +
        this.invoiceDate.split("-")[1] +
        "/" +
        this.invoiceDate.split("-")[0];
    }

    this.subTotal = 0;

    this.itemsArray.forEach(element => {
      this.subTotal += element.total
    });

    this.calculateGst();



  }


  calculateGst = function () {
    this.cgstRupee = Math.round((this.subTotal * 9) / 100);
    this.sgstRupee = Math.round((this.subTotal * 9) / 100);
    this.totIncGst =
      parseFloat(this.subTotal) +
      (parseInt(this.cgstRupee) + parseInt(this.sgstRupee));

    this.cgstRupeeWord = this.numberToWordsPipe.transform(this.cgstRupee);
    this.cgstRupeeWord =
      this.cgstRupeeWord.charAt(0).toUpperCase() + this.cgstRupeeWord.slice(1);
    this.sgstRupeeWord = this.numberToWordsPipe.transform(this.sgstRupee);
    this.sgstRupeeWord =
      this.sgstRupeeWord.charAt(0).toUpperCase() + this.sgstRupeeWord.slice(1);

    this.totIncGstRupeeWord = this.numberToWordsPipe.transform(
      Math.floor(this.totIncGst)
    );
    this.totIncGstRupeeWord =
      this.totIncGstRupeeWord.charAt(0).toUpperCase() +
      this.totIncGstRupeeWord.slice(1);
  };

  print = function (billContent) {
    var elementToPrint = document.getElementById(billContent); //The html element to become a pdf

    document.body.innerHTML = document.getElementById(billContent).innerHTML;
    window.print();
    location.reload();
  };

}



// WEBPACK FOOTER //
// ./src/app/scrap/scrap.component.ts